'use client'

import React from 'react'
import styles from './styles.module.scss'

interface Props {
    message: string
}

export default function BaseError(props: Props) {
    return (
        <section className={styles.section}>
            <p className={`${styles.paragraph} font-xmd`}>{props.message}</p>
            <span onClick={() => window.location.reload()} className={`${styles.link} font-md`} >Tentar novamente</span>
        </section>
    )
}
